// @flow

import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import { Redirect }           from 'react-router';
import { getTranslate }       from 'react-localize-redux';
import { offerCompareOffers, offerSaveCompareOffers } from 'actions/offer/offer';
import ReactLoading           from 'react-loading';
import RoutesURL              from 'routes/routes';
import toolHelper             from 'helpers/tools.helper';
import urlHelper              from 'helpers/url.helper';

class CalculatorBestPackage extends Component {

  idleTimeout = null;
  prefillInputvalue = true;
  requestedOrderId = null;

  state = {
    idleTimer             : null,
    defaultTimeout        : 0,    // 0 sec
    defaultAutoSaveTimeout: 2000, // 2 sec
    enableAutoSave        : false,
    showLoadingIcon       : true,
    initialCheckPerformed : false,
    offersLoaded          : false,

    // Current application
    currentOrderId  : 0,

    statusPercentage: 0,
    productPrices   : {},
    productRisks    : {},
    offers          : {},

    // Current insurance company details
    currentSubtotal : 0,
    currentTotal    : 0,
    currentDiscount : 0,

    // New insurance company defaults
    newSubtotal         : {},
    newTotal            : {},
    newDiscount         : {},
    newSaving           : {},
    newSavingPercentage : {}
  }

  constructor() {
    super();
    this.idleTimeout = null;

    this._handleProductRisks  = this._handleProductRisks.bind(this);
    this._handleProductPrices = this._handleProductPrices.bind(this);
    this._handleOnFocus       = this._handleOnFocus.bind(this);
    this._handleOnBlur        = this._handleOnBlur.bind(this);
    this._handleResponsiveSwipe = this._handleResponsiveSwipe.bind(this);
  }

  componentDidMount() {
    const { currentApp } = this.props;
    this._handleChangeApp(currentApp);

    // Auto save data to DB
    if( this.state.enableAutoSave ) {
      this._autoSaveData();
    }

    // Action for mobile only:
    //  - hide product titles on the left while swipping from left to right
    document.getElementsByClassName('scrollable-area')[0].addEventListener('scroll', this._handleResponsiveSwipe);
  }

  componentWillReceiveProps(nextProps) {
    this._handleChangeApp(nextProps.currentApp);
  }

  _calculateEverything() {
    setTimeout(function() {
      // Calculate current
      const { currentTotal, currentSubtotal } = this._calculateCurrent();
      this.setState({
        currentTotal: currentTotal,
        currentSubtotal: currentSubtotal
      }, function() {
        // Calculate new
        this._calculateNew(function() {
          this.setState({ currentTotal: currentTotal, currentSubtotal: currentSubtotal }, function() {
            // Highlight cheapest offer
            this._highlightCheapestOffer();
          });
        });
      });
    }.bind(this), this.state.defaultTimeout);
  }

  _handleChangeApp = (currentApp: any) => {
    const { dispatch, history } = this.props;
    let self = this;

    this.setState({initialCheckPerformed: false});

    if( currentApp ) {
      const order_id = currentApp.order_id;
      this.requestedOrderId = order_id;
      this.setState({ currentOrderId: order_id, offersLoaded: false });

      // Note that company with ID = 60 is just a workaround company for "I don't have insurance"
      //  - that is why it must be fixed.... for now
      dispatch(offerCompareOffers(order_id, history)).then(res => {
        // Ignore response for previously selected application
        if( self.requestedOrderId !== order_id ) return;

        const data = res ? res.data : null;

        if( data && data.status !== false ) {
          const currentProductOffers = data.current_offer && Array.isArray(data.current_offer.product_offers) ? data.current_offer.product_offers : [];
          self.setState({
            // Set discount for current insurance company
            currentDiscount: (currentProductOffers[0] ? currentProductOffers[0].discount : 0),
            // Save all offers to a state
            offers: data,
            // Enable autosave when data is populated
            enableAutoSave: true
          });
        } else {
          // Don't keep offers from previously selected application
          self.setState({ currentDiscount: 0, offers: {}, enableAutoSave: false });
        }

        // Clear loading icon
        self.setState({ showLoadingIcon: false, offersLoaded: true });
        self._calculateEverything();
      }).catch(() => {
        if( self.requestedOrderId !== order_id ) return;

        // Network error or 5xx - clear loading icon, but don't claim prices are missing
        self.setState({ showLoadingIcon: false });
      });
    }
  }

  _handleResponsiveSwipe = (e: any) => {
    const { target } = e;
    if(  target.scrollLeft > 0 ) {
      document.querySelectorAll('body')[0].classList.add('cols-scrolled');
    } else {
      document.querySelectorAll('body')[0].classList.remove('cols-scrolled');
    }
  }

  render() {
    const { translate, currentApp } = this.props;
    const {
      offers: { current_offer, new_offers, products },
      currentDiscount, currentSubtotal , currentTotal,
      newTotal, newSaving, newSavingPercentage,
      showLoadingIcon, offersLoaded
    } = this.state;
    let loadingIcon = null;
    const hasCurrentPrices = Boolean(current_offer && current_offer.product_offers && current_offer.product_offers.length);
    // Company with ID = 60 is the "I don't have insurance" placeholder, so there are no current prices to expect
    const isNoInsurancePlaceholder = Boolean(current_offer && current_offer.company && current_offer.company.id === 60);

    // Check if application ID exists
    if( !currentApp ) {
      return (<Redirect to={RoutesURL.logout()} />);
    }

    // Loading icon
    if( showLoadingIcon ) {
      loadingIcon = <ReactLoading type='spin' height='34px' width='34px' color='#8bb91d' className='loading-icon' />
    }

    return (
      <div className="calculator-bestpackage">
        {loadingIcon}
        <div className="title-panel">
          <p><em>{translate('calculator.best_package.description')}</em></p>
          {offersLoaded && !hasCurrentPrices && !isNoInsurancePlaceholder &&
            <p className="no-current-prices">{translate('calculator.best_package.no_current_prices')}</p>
          }
        </div>
        <div className="calc-holder">
          <div className="titles-block">
            <div className="message-widget">
              <h3>{translate('calculator.best_package.nick_description.headline')}</h3>
              <p><em>{translate('calculator.best_package.nick_description.description')}</em></p>
              <div className="img">
                <img src='images/img-002.png' alt="Nick" />
              </div>
            </div>
            <div className="products-title"><h3>{translate('calculator.your_insurances')}</h3></div>

            <ul className="products-titles">
              {products && products.map((item, index) =>
                <li key={index} className={'ico ' + item.url_alias}><span>{item.name}</span></li>
              )}
            </ul>
            <ul className="summary-titles">
              <li><span><b>{translate('common.total')}</b></span></li>
              <li><span><strong>{translate('calculator.savings_in_dkk')}</strong></span></li>
              <li><span><strong>{translate('calculator.savings_in_percent')}</strong></span></li>
            </ul>
          </div>

          <div className="scrollable-area">
            <div className="row">
              <div className={'col-xs-3 current-company ' + (current_offer && current_offer.company.id === 60 ? 'hide' : '')}>
                <div className="vals-box type3">
                  <div className="holder">
                    <header className="heading">
                      <div className="title-box">
                        <h3>{translate('calculator.current_company')}</h3>
                      </div>
                    </header>
                    <div className="row">
                      <div className="col-xs-6">
                        <h4>{translate('calculator.excess')}</h4>
                        {current_offer && current_offer.product_offers && current_offer.product_offers.map((item, index) =>
                          <input key={index} id={item.id} defaultValue={item.risk} ref={'current-product-risks-' + item.id} type='text' data-current='true' className='form-control' placeholder='0' onChange={this._handleProductRisks} />
                        )}
                      </div>
                      <div className="col-xs-6">
                        <h4>{translate('common.price_in_dkk')}</h4>
                        {current_offer && current_offer.product_offers && current_offer.product_offers.map((item, index) =>
                          <input key={index} id={item.id} defaultValue={item.price} ref={'current-product-prices-' + item.id} type='text' data-current='true' className='form-control' placeholder='0' onChange={this._handleProductPrices} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="summary-box">
                  <ul className="summary-vals">
                    <li><b>{currentTotal}</b></li>
                    <li>{currentSubtotal}</li>
                    <li>{currentDiscount} %</li>
                  </ul>
                  <span className="check-note">{translate('calculator.cheapest_solution')}</span>
                </div>
              </div>

              {new_offers && new_offers.map((offer, index) => {
                const { product_offers } = offer;
                const appCompany = currentApp.app_companies.find((item) => item.company_id === offer.company.id);

                if (appCompany && appCompany.direct_offer && !this.state.initialCheckPerformed) {
                  this.setState({initialCheckPerformed: true});
                  let tempOffer = product_offers.find((i) => i.name === appCompany.direct_offer.product_name );

                  if (tempOffer.risk === 0) {
                    tempOffer.risk = parseInt(appCompany.direct_offer.deduction, 0);
                  }

                  if (tempOffer.price === 0) {
                    tempOffer.price = parseInt(appCompany.direct_offer.price, 0);
                  }
                }

                return(
                  <div className={'col-xs-3 company company-' + offer.company.id} key={index}>
                    <div className='vals-box type3'>
                      <div className='holder'>
                        <em className='number'>{index}</em>
                        <header className='heading'>
                          <div className='title-box'>
                            <div className='title-logo logo-01'>
                              <img src={urlHelper.imageUrl(offer.company.meta_logo_medium)} alt="Company logo" />
                            </div>
                          </div>
                        </header>
                        <div className='row'>
                          <div className='col-xs-6'>
                            <h4>{translate('calculator.excess')}</h4>
                            {product_offers && product_offers.map((item, index) =>
                              <input key={index} onBlur={this._handleOnBlur} onFocus={this._handleOnFocus} data-company-id={offer.company.id} id={item.id} defaultValue={item.risk} ref={'product-risks-' + offer.company.id + '-' + item.id} type='text' className='form-control' placeholder='0' onChange={this._handleProductRisks} />
                            )}
                          </div>
                          <div className='col-xs-6'>
                            <h4>{translate('common.price_in_dkk')}</h4>
                            {product_offers && product_offers.map((item, index) =>
                              <input key={index} onBlur={this._handleOnBlur} onFocus={this._handleOnFocus} data-company-id={offer.company.id} id={item.id} defaultValue={item.price} ref={'product-prices-' + offer.company.id + '-' + item.id} type='text' className='form-control' placeholder='0' onChange={this._handleProductPrices} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='summary-box'>
                      <ul className='summary-vals'>
                        <li><b>{newTotal[offer.company.id]}</b></li>
                        <li>{newSaving[offer.company.id]}</li>
                        <li>{newSavingPercentage[offer.company.id]} %</li>
                      </ul>
                      <span className="check-note">{translate('calculator.cheapest_solution')}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  _highlightCheapestOffer = () => {
    let currentSelectedCol = document.getElementsByClassName('company selected');
    if( currentSelectedCol.length ) {
      for( let i = 0; i < currentSelectedCol.length; i++ ) {
        currentSelectedCol[i].classList.remove('selected');
      }
    }

    currentSelectedCol = document.getElementsByClassName('current-company selected');
    if( currentSelectedCol.length ) {
      currentSelectedCol[0].classList.remove('selected');
    }

    // Prepare variables for lowest total
    let bestSavingValue = Infinity,
        bestSavingKey   = '';
    const { newTotal, currentTotal } = this.state;

    // Go through all totals and find the lowest one
    let allTotals = Object.assign({}, newTotal, { '0': currentTotal });
    Object.keys(allTotals).map(key => {
      let item = allTotals[key];

      if( item < bestSavingValue && item !== 0 ) {
        bestSavingValue = item;
        bestSavingKey   = Number(key);
      }
      return true;
    });

    // Select new cheapest offer (add class to block / column)
    let newSelectedCol = document.getElementsByClassName('company-' + bestSavingKey);
    if( newSelectedCol && newSelectedCol.length ) {
      newSelectedCol[0].classList.add('selected');

      // We have to set savings for current company to zero
      if( this.state.currentTotal ) {
        this.setState({ currentSubtotal: 0 });
      }
    } else {
      let currentCompany = document.getElementsByClassName('current-company');
      if( currentCompany.length ) {
        currentCompany[0].classList.add('selected');
      }
    }
  }

  _handleProductRisks = (e) => {
    // First we have to set new value for input and store it into state
    const isCurrent = Boolean(e.target.dataset.current);
    this._storeProductPriceRisk(e, 'risk', isCurrent);

    // Auto save data to DB
    if( this.state.enableAutoSave ) {
      this._autoSaveData();
    }

    return true;
  }

  _handleProductPrices = (e) => {
    const self = this;

    // First we have to set new value for input and store it into state
    const isCurrent = Boolean(e.target.dataset.current);
    this._storeProductPriceRisk(e, 'price', isCurrent);

    // Calculate current
    const { currentTotal, currentSubtotal } = this._calculateCurrent();

    this.setState({
      currentTotal: currentTotal,
      currentSubtotal: currentSubtotal
    }, function() {
      // Calculate new
      this._calculateNew(function() {
        this.setState({ currentTotal: currentTotal, currentSubtotal: currentSubtotal }, function() {
          // Highlight cheapest offer
          self._highlightCheapestOffer();
        });
      });
    });

    // Auto save data to DB
    if( this.state.enableAutoSave ) {
      this._autoSaveData();
    }
    return true;
  }

  _storeProductPriceRisk = (e: any, type: string = '', isCurrent: bool = false) => {
    if( type === '' ) return false;

    const storeKey = type === 'price' ? 'price' : 'risk';
    const { target, target: { dataset: { companyId }, id } } = e;
    let foundCompanyIndex = false,
        foundProductIndex = false;

    if( isCurrent ) {
      this.state.offers.current_offer.product_offers.map((item, index) => {
        if( item.id === parseInt(id, 10) ) {
          foundProductIndex = index;
        }
        return true;
      });
      if( foundProductIndex !== false ) {
        //eslint-disable-next-line
        this.state.offers.current_offer.product_offers[foundProductIndex][storeKey] = parseFloat(target.value);
      }
    } else {
      this.state.offers.new_offers.map(function(item, index) {
        if( item.company.id === parseInt(companyId, 10) ) {
          foundCompanyIndex = index;
          item.product_offers.map(function(product, product_index) {
            if( product.id === parseInt(id, 10) ) {
              foundProductIndex = product_index;
            }
            return true;
          });
        }
        return true;
      });
      if( foundCompanyIndex !== false && foundProductIndex !== false ) {
        //eslint-disable-next-line
        this.state.offers.new_offers[foundCompanyIndex].product_offers[foundProductIndex][storeKey] = parseFloat(target.value);
      }
    }
  }

  _handleOnFocus = (e: any) => {
    const { target } = e;
    let boxValsContainer = target.closest('.vals-box');
    if( !boxValsContainer ) return false;

    Array.prototype.map.call(boxValsContainer.classList, (item) => { return item ==='type3' ? 'type4' : item });
  }

  _handleOnBlur = (e: any) => {
    const { target } = e;
    let boxValsContainer = target.closest('.vals-box');
    if( !boxValsContainer ) return false;

    Array.prototype.map.call(boxValsContainer.classList, (item) => { return item ==='type4' ? 'type3' : item });
  }

  _autoSaveData = () => {
    this.setState({ showLoadingIcon: true });
    this._destroyTimeout();
    this.idleTimeout = setTimeout(function() {
      let product_offers      = [],
          input_productRisks  = [],
          input_productPrices = [],
          inputs              = this.refs,
          self                = this;
      const { currentDiscount, newDiscount, currentOrderId } = this.state;
      const { dispatch } = this.props;

      // Populate product risks and prices inputs
      Object.keys(inputs).map(function(val, key) {
        if( val.includes('product-prices') !== false ) {
          input_productPrices.push(inputs[val]);
        }
        if( val.includes('product-risks') !== false ) {
          input_productRisks.push(inputs[val]);
        }
        return true;
      });

      if( input_productPrices && input_productPrices.length ) {
        input_productPrices.forEach(function(item, key) {
          let th_input        = item,
              th_input_id     = parseInt(th_input.id, 10),
              th_input_value  = toolHelper.formatNumber(th_input.value) || 0,
              th_company_id   = parseInt(th_input.dataset.companyId, 10);

          // If current
          if( !th_company_id ) {
            product_offers.push({
              id: th_input_id,
              risk: (input_productRisks[key] ? input_productRisks[key].value : 0),
              price: th_input_value,
              discount: (!currentDiscount ? 0 : currentDiscount)
            });
          } else {
            product_offers.push({
              id: th_input_id,
              risk: (input_productRisks[key] ? input_productRisks[key].value : 0),
              price: th_input_value,
              discount: (!newDiscount[th_company_id] ? 0 : newDiscount[th_company_id])
            });
          }
        });
      }

      if( product_offers && product_offers.length ) {
        let data = {
          product_offers: product_offers
        };

        // Make a API call and save all product offers
        dispatch(offerSaveCompareOffers(currentOrderId, data)).then(res => {
          self.setState({ showLoadingIcon: false });
        });
      }
      this.setState({ showLoadingIcon: false });

    }.bind(this), this.state.defaultAutoSaveTimeout);
  }

  _destroyTimeout = () => {
    clearTimeout(this.idleTimeout);
    this.idleTimeout = null;
  }

  // Calculate current insurance company prices
  _calculateCurrent = () => {
    const { currentDiscount, offers: { current_offer } } = this.state;
    let subtotal     = 0,
        currentTotal = 0,
        inputs       = this.refs;

    // Backend can return { status: false } or no current offer at all
    if( !current_offer || !Array.isArray(current_offer.product_offers) ) {
      return { currentTotal: 0, currentSubtotal: 0 };
    }

    current_offer.product_offers.map(val => {
      let inputValue = parseFloat(val.price) || 0;
      subtotal += inputValue;

      // Set input value
      let input_risk  = inputs['current-product-risks-' + val.id],
          input_price = inputs['current-product-prices-' + val.id];
      if( input_risk && input_price ) {
        input_risk.value = val.risk;
        input_price.value = inputValue;
      }

      return true;
    });

    currentTotal = parseFloat(subtotal) - (( parseFloat(subtotal) * parseFloat(currentDiscount) ) / 100);
    return { currentTotal: currentTotal, currentSubtotal: subtotal };
  }

  // Calculate new insurance companies prices
  _calculateNew = (stateCallback: any) => {
    const { offers: { new_offers } } = this.state;
    let inputs   = this.refs,
        subtotal = {};

    if( !Array.isArray(new_offers) ) return false;

    new_offers.map(function(val, key) {
      if( !val || !val.company || !Array.isArray(val.product_offers) ) return false;
      let companyId = val.company.id;
      if( !companyId ) return false;

      // Set default value if subtotal for company is not defined yet
      if( subtotal[companyId] === undefined || subtotal[companyId] === null || subtotal[companyId] === "" ) {
        subtotal[companyId] = 0;
      }

      val.product_offers.map(function(item) {
        subtotal[companyId] += parseFloat(toolHelper.formatNumber(item.price));

        // Set input value
        let input_risk  = inputs['product-risks-' + companyId + '-' + item.id],
            input_price = inputs['product-prices-' + companyId + '-' + item.id];
        if( input_risk && input_price ) {
          input_risk.value = item.risk;
          input_price.value = item.price;
        }

        return true;
      });
      return true;
    });

    let { newDiscount, currentTotal } = this.state;
    Object.keys(subtotal).map(key => {
      let value = subtotal[key];

      if( !newDiscount[key] ) newDiscount[key] = 0;

      let companyValue = value,
          companyTotal = parseFloat(value) - ((parseFloat(value) * parseFloat(newDiscount[key])) / 100);

      let stateCopy = null;
      stateCopy = Object.assign({}, this.state);
      stateCopy.newSubtotal[key] = companyValue;
      stateCopy.newTotal[key]    = companyTotal;
      stateCopy.newSaving[key]   = currentTotal - companyTotal;
      stateCopy.newSaving[key]   = stateCopy.newSaving[key] < 0 ? 0 : stateCopy.newSaving[key]; // Don't go into negative numbers
      stateCopy.newSaving[key]   = companyTotal === 0 ? 0 : stateCopy.newSaving[key]; // If company total is zero, then there is no saving
      stateCopy.newSavingPercentage[key] = Math.round((1 - (companyTotal / currentTotal)) * 100);
      stateCopy.newSavingPercentage[key] = !stateCopy.newSavingPercentage[key] || currentTotal < 1 ? 0 : stateCopy.newSavingPercentage[key];
      stateCopy.newSavingPercentage[key] = stateCopy.newSavingPercentage[key] < 0 ? 0 : stateCopy.newSavingPercentage[key];
      stateCopy.newSavingPercentage[key] = companyTotal === 0 ? 0 : stateCopy.newSavingPercentage[key]; // If company total is zero, then there is no percentage
      return this.setState(stateCopy, stateCallback);
    }, this);

    return true;
  }
}

const mapStateToProps = state => ({
  translate : getTranslate(state.locale),
  app       : state.application,
  currentApp: state.application.activeApplication
});

export default connect(mapStateToProps)(CalculatorBestPackage);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/calculatorBestPackage.js